var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngleLeft = function SvgAngleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.849 5.434c.198.198.296.297.334.411.032.1.032.21 0 .31-.038.114-.136.213-.335.41L10.415 12l5.435 5.434c.198.198.296.297.334.412.032.1.032.208 0 .308-.038.115-.136.214-.335.412l-.282.283c-.198.198-.297.296-.412.334a.5.5 0 0 1-.309 0c-.114-.038-.213-.136-.41-.334L8.15 12.566c-.198-.198-.297-.297-.334-.412a.5.5 0 0 1 0-.309c.037-.114.136-.213.334-.41l6.283-6.284c.198-.198.297-.297.412-.334a.5.5 0 0 1 .309 0c.114.037.213.136.41.334z",
    clipRule: "evenodd"
  })));
};
export default SvgAngleLeft;